import { BookingApi } from '@linktivity/ars-neo';
import config from './config';

const bookingApi = new BookingApi(config);

export default bookingApi;
